import { generateID } from './syllabus-block-utils';

export default {
  props: { 
    isTitle: {
      type: Boolean,
      default: false
    },
    uuid: {
      type: String,
      required: true
    },
    isEditing: {
      type: Boolean
    },
    editable: {
      type: Boolean,
      default: true
    },
    showReorder: {
      type: Boolean 
    },
    showOnPublicSyllabus: {
      type: Boolean
    }
  },
  template: '#block-template',
  data() {
    return {
      hover: false,
      padBlockContent: true,
    };
  },
  computed: {
    titleClass() {
      return this.isTitle ? 'block-container__title' : '';
    }
  },
  methods: {
    setHover() {
      this.hover = true;
      this.$emit('set-hover', true);
    },
    unsetHover() {
      this.hover = false;
      this.$emit('unset-hover', false);
    },
    componentClick(e) {
      if ( this.shouldToggle(e) ) {
        this.$emit('toggle-edit');
      }
    },
    shouldToggle(e) {
      const path = this.getPathForEvent(e);
      return path.filter( ele => {
        const classes = ele.classList;
        if ( classes ) {
          return classes.contains('js-no-toggle');
        }

        return false;
      }).length == 0; 
    },
    getPathForEvent(e) {
      // Handle MouseEvent vs Click descrepancies between chrome and ff/safari
      if (e.path) {
        return e.path;
      }
      
      let path = [];
      let element = e.target;
      while(element) {
        path.push(element);
        element = element.parentElement;
      }
      if (path.indexOf(window) === -1 && path.indexOf(document) === -1) {
        path.push(document);
      }
      if (path.indexOf(window) === -1) {
        path.push(window);
      }

      return path;

    },
    destroy() {
      this.$root.destroyBlock(this.uuid);
    },
    copy() {
      this.$root.copyBlock(this.uuid);
    },
  },
  mounted() {
    if(this.showReorder) {
      this.tooltip = new Kadenze.Tooltip({
        target: `#tooltip-target-${this.uuid}`,
        template: 'templates/tooltips/syllabus/reorder',
        position: 'right',
        arrow: true,
        eventIn: null,
        interactive: {
          context: 'syllabus-reorder',
          order: 0,
        }
      });
      this.tooltip.show();
      this.$root.shownReorder = true;
    }
  },
};
